import { useQuery } from '@tanstack/react-query';

import { rolesService } from '@/services/apiClient';

/**
 * Roles Hooks
 * React Query hooks for /api/v1/roles/* and /api/v1/user-roles/* endpoints
 */

// Query keys
export const roleKeys = {
  all: ['roles'] as const,
  list: (orgId?: string) => [...roleKeys.all, 'list', orgId] as const,
  userRoles: (userId: string) => [...roleKeys.all, 'user', userId] as const,
};

/**
 * Hook to fetch roles for an organization
 */
export const useRoles = (organizationId?: string) => {
  return useQuery({
    queryKey: roleKeys.list(organizationId),
    queryFn: () => rolesService.getRoles(organizationId),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

/**
 * Hook to fetch user roles by user ID
 */
export const useUserRoles = (userId: string | undefined, enabled = true) => {
  return useQuery({
    queryKey: roleKeys.userRoles(userId || ''),
    queryFn: () => rolesService.getUserRoles(userId || ''),
    enabled: enabled && !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

